export const EVENTS = {
    'LOGIN_EVENT': 'Login',
    'KYC': {
        'KYC_STARTED':'KYCStarted',
        'KYC_COMPLETE':'KYCComplete',
        'KYC_RETRY': 'KYCRetry',
    },
    'KYB': {
        'KYB_STARTED':'KYBStarted',
        'KYB_COMPLETE':'KYBComplete',
        'KYB_RETRY': 'KYBRetry',
    },
    GETTING_STARTED: {
        title: 'Getting Started Page',
        'PAGE': 'page',
        clickedOnSupport: 'Clicked on support email'
    },
    HOME_PAGE: {
        title: 'Home Page',
    },
    'HELP': {
        'HELP_BUTTON': 'HelpButton',
        'HELP_LINK':'HelpLink'
    },
    '2FA': {
        '2FA_DISMISS': '2FADismiss',
        '2FA_SETUP': '2FASetup',
        '2FA_COMPLETED': '2FACompleted'
    },
    'STATEMENTS': {
        'STATEMENT_DISMISS': 'Statement pop-up dismissed',
        'STATEMENT_MENU_OPENED': 'Statement menu opened',
        'STATEMENT_DOWNLOADED': 'STATEMENT DOWNLOADED',
        'STATEMENT_DOWNLOAD_ERROR': 'Statement download error'
    },
    BANK_TRANSFER: {
        BANK_SELECTED: 'bank_selected',
        BANK_STEP_SELECTED: 'bank_step_selected',
        BANK_DELETE: 'bank_deleted',
        ADD_BANK_SELECTED: 'add_bank_selected',
        CURRENCY_SELECTED: 'currency_selected',
        COUNTRY_SELECTED: 'country_selected',
        COUNTRY_CURRENCY_CONTINUE: 'country_currency_continue',
        BANK_FORM_LOADED: 'bank_form_loaded',
        BANK_FORM_ERROR: 'bank_form_error',
        BANK_FORM_SAVED: 'bank_form_saved',
        BANK_POPUP_LIMIT_REACHED: 'bank_popup_limit_reached',
        BANK_POPUP_LIMIT_REACHED_OK: 'bank_popup_limit_reached_ok',
        BANK_POPUP_BETA: 'bank_popup_beta',
        BANK_POPUP_BETA_CONTINUE: 'bank_popup_beta_continue',
        BANK_POPUP_BETA_CANCEL: 'bank_popup_beta_cancel',
        BANK_TRANSFER_INITIATED: 'bank_transaction_initiated',
        BANK_TRANSFER_FAILED: 'bank_transaction_failed',
        BANK_DELETE_CANCEL: 'bank_delete_canceled',
        BANK_BACK_TO_HOME: 'bank_back_to_home',
        BANK_ACCOUNT_MENU_SELECTED: 'bank_account_menu_selected',
    }
};

export const ACTIVITY_DETAIL = {
    'KYC' : {
        'KYC_STARTED':'Payee started the KYC process by clicking on Start verification',
        'KYC_COMPLETE':'Payee has seen final KYC Status as (Success)',
        'KYC_FAIL':'Payee has seen final KYC Status as (Fail)',
        'KYC_RETRY': 'Payee retries for KYC from dashboard',
    },
    'KYB' : {
        'KYB_STARTED':'Payee started the KYB process by clicking on Start verification',
        'KYB_COMPLETE':'Payee has seen final KYB Status as (Success)',
        'KYB_FAIL':'Payee has seen final KYB Status as (Fail)',
        'KYB_RETRY': 'Payee retries for KYB from dashboard',
    },
    'HELP': {
        'HELP_BUTTON': 'User clicked the help button on payee portal',
        'HELP_LINK':'When payee clicked on any one of the prepopulated links',
        'HELP_BUTTON_CLOSE': 'User closed the help button on payee portal',
    },
    '2FA': {
        '2FA_DISMISS': 'Payee dismiss 2FA pop-up',
        '2FA_SETUP': 'Payee started on setup button for 2FA',
        '2FA_COMPLETED': 'Payee completed 2FA setup'
    },
    'STATEMENTS': {
        'STATEMENT_DISMISS': 'Payee dismiss Statement pop-up',
        'STATEMENT_MENU_OPENED': 'Monthly Statement Visited',
        'STATEMENT_DOWNLOADED': 'Monthly Statement Downloaded',
        'STATEMENT_DOWNLOAD_ERROR': 'Statement download error due to popup block'
    }
}

export const ACTIVITY_META = {
    'KYC' : {
        'KYC_FAIL': 'Fail',
        'KYC_SUCCESS': 'Success',
        'KYC_RETRY' : 'KYC Retry',
        'FROM_DASHBOARD': 'From Dashboard',
        'AFTER_TRANSFER': 'After Transfer Button',
        'AFTER_CRYPTO': 'After Crypto Selection',
        'AFTER_NON_CRYPTO': 'After Non-Crypto',
        'KYC_MANUAL_REVIEW': 'KYC manual review',
        'KYC_BLOCKED': 'KYC blocked',
    },
    'KYB' : {
        'KYB_FAIL': 'Fail',
        'KYB_SUCCESS': 'Success',
        'KYB_RETRY' : 'KYB Retry',
        'KYB_MANUAL_REVIEW': 'KYB manual review',
        'KYB_BLOCKED': 'KYB blocked',
        'FROM_DASHBOARD': 'From Dashboard',
        'AFTER_TRANSFER': 'After Transfer Button',
        'AFTER_CRYPTO': 'After Crypto Selection',
        'AFTER_NON_CRYPTO': 'After Non-Crypto',
    },
    'HELP': {
        'HELP_BUTTON': 'Help Button was pressed to open help',
        'HELP_LINK': 'Link has been clicked for help'  ,
        'HELP_BUTTON_CLOSE': 'Help button was clicked to close help' 
    },
    '2FA': {
        'FROM_POPUP': 'Pop-up',
        'FROM_MENU':  'Menu',
        'FROM_STATEMENTS': 'Statements'
    }
}
